/* global google */
import { useEffect, useState } from 'react';

import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { Skeleton } from 'antd';

import { MapPoint, TONES } from './ocpiHelpers';
import * as S from './styled';

interface Props {
  points: MapPoint[];
  onSelect?: (id: string) => void;
}

const DEFAULT_CENTER = { lat: -27.5713144, lng: -48.75047 };

const OcpiStationMap = ({ points, onSelect }: Props) => {
  const { isLoaded } = useLoadScript({ googleMapsApiKey: process.env.REACT_APP_GOOGLE_API as string });
  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (!map || !points.length) return;
    const bounds = new google.maps.LatLngBounds();
    points.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
    map.fitBounds(bounds, 40);
  }, [map, points.length]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isLoaded) return <Skeleton active />;

  return (
    <S.MapBox>
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={DEFAULT_CENTER}
        zoom={10}
        onLoad={setMap}
        options={{ streetViewControl: false, mapTypeControl: false }}
      >
        {points.map((point) => (
          <Marker
            key={point.id}
            position={{ lat: point.lat, lng: point.lng }}
            title={point.title}
            onClick={() => onSelect?.(point.id)}
            icon={{
              path: google.maps.SymbolPath.CIRCLE,
              scale: 9,
              fillColor: TONES[point.tone].fg,
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 2,
            }}
          />
        ))}
      </GoogleMap>
    </S.MapBox>
  );
};

export default OcpiStationMap;
